export const DEFAULT_ASSISTANT_NAME = 'PAPI'

export const DEFAULT_ASSISTANT_GREETING = 'Panelpunches AI, ask me anything about orders, customer or products.'

// Decimal places every credit amount is shown with (FR-35) — balance and per-call usage alike.
export const CREDIT_DECIMALS = 6
